module.exports = __webpack_public_path__ + "static/moloch-6d5f7e598af9d15479e432386278b9c3.png";